{
  "processing": "正在处理验证...",
  "loadingIframe": "正在加载身份验证...",
  "issueTitle": "身份验证问题",
  "notConfigured": "该仓库尚未正确配置身份验证功能。",
  "notSuccessful": "身份验证未成功，请重试或联系仓库。",
  "couldNotCompleteProceed": "身份验证未能完成，但您可以继续签到。",
  "processFailed": "处理身份验证失败，请重试。",
  "processingFailedProceed": "身份验证处理失败，但您可以继续签到。",
  "genericError": "身份验证过程中发生错误，请重试。",
  "issueProceed": "身份验证遇到问题，但您可以继续签到。",
  "requiredTryAgain": "完成签到需要进行身份验证，请重试。",
  "checkInFailedTitle": "无法签到",
  "checkInFailedMessage": "无法验证您的身份证件"
}
